const RelationalModel = require('../extensions/relational-model.js');
const RelationalCollection = require('../extensions/relational-collection.js');
const parameters = require('./parameters.js');
const moment = require('moment');

const Booking = RelationalModel.extend({
  mutators: {
    beginDate() {
      return moment(this._get('beginDate')).toDate();
    },
    endDate() {
      return moment(this._get('endDate')).toDate();
    },
    time() {
      const beginMoment = moment(this.get('beginDate'));
      const endMoment = moment(this.get('endDate'));

      const start = beginMoment.format('HH[H]mm');
      const duration = endMoment.diff(beginMoment, 'minutes');

      return `${start} (${duration}')`;
    },
    section() {
      const hour = this.get('hour');

      switch (true) {
        case hour < '09':
          return 0; // Tôt
        case hour < '12':
          return 1; // Matin
        case hour < '14':
          return 2; // Midi
        case hour < '19':
          return 3; // Après-midi
        default:
          return 4; // Soir
      }
    },
    hour() {
      return moment(this.get('beginDate')).format('HH');
    },
    day() {
      return moment(this.get('beginDate')).format('E');
    },
    isFromScheduledBooking() {
      return this._has('isFromScheduledBooking') ? this._get('isFromScheduledBooking') : true;
    }
  }
});

const BookingCollection = RelationalCollection.extend({
  model: Booking,
  url() {
    return `${parameters.get('api_base_url')}/${parameters.get('client_token')}/bookings`;
  },
  comparator: 'beginDate'
});

module.exports = new BookingCollection();

// declare parse method after module export to avoid cyclic dependency
Booking.prototype.parse = function(response) {
  if (response.activityIdList && response.activityIdList[0]) {
    const activities = require('./activities.js');
    response.activity = activities.merge(
      {
        id: response.activityIdList[0]
      },
      { parse: true }
    );
  }

  if (response.coachIdList && response.coachIdList[0]) {
    const coaches = require('./coaches.js');
    response.coach = coaches.merge(
      {
        id: response.coachIdList[0]
      },
      { parse: true }
    );
  }

  if (response.studioIdList[0]) {
    const studios = require('./studios.js');
    response.studio = studios.merge(
      {
        id: response.studioIdList[0]
      },
      { parse: true }
    );
  }

  return response;
};



// WEBPACK FOOTER //
// ./src/data/bookings.js